import { Cookies } from 'utils'


export const types = {
  SET_BIND_CARD: 'userCards/SET_BIND_CARD',
  SET_CARD: 'userCards/SET_CARD',

  LOAD_CARDS_REQUEST: 'userCards/LOAD_CARDS_REQUEST',
  LOAD_CARDS_COMPLETED: 'userCards/LOAD_CARDS_COMPLETED',
  LOAD_CARDS_FAILED: 'userCards/LOAD_CARDS_FAILED',

  UPDATE_CARD_REQUEST: 'userCards/UPDATE_CARD_REQUEST',
  UPDATE_CARD_COMPLETED: 'userCards/UPDATE_CARD_COMPLETED',
  UPDATE_CARD_FAILED: 'userCards/UPDATE_CARD_FAILED',

  REMOVE_CARD_REQUEST: 'userCards/REMOVE_CARD_REQUEST',
  REMOVE_CARD_COMPLETED: 'userCards/REMOVE_CARD_COMPLETED',
  REMOVE_CARD_FAILED: 'userCards/REMOVE_CARD_FAILED'
}

const initialState = { can_bind_card: false, user_cards: null };

export default function reducer(state = initialState, action = {}) {
  let userCards = state.user_cards ? [ ...state.user_cards ] : [];

  switch (action.type) {
    case types.SET_BIND_CARD: return { ...state, can_bind_card: action.can_bind };

    case types.SET_CARD:
      const { bincode, issuer_zh_tw, lastfour } = action.card;
      const removeParams = { path: '/' };
      const setParams = {
        path     : '/',
        maxAge   : 60 * 60 * 24 * 1,
        sameSite : 'Lax',
        secure   : true,
      };

      Cookies.remove('card_no', removeParams);
      Cookies.set('card_no', `${bincode}******${lastfour}`, setParams);
      Cookies.remove('issuer', removeParams);
      Cookies.set('issuer', issuer_zh_tw, setParams);

      /*
      bank_id: "822"
      bincode: "424242"
      country: "TAIWAN R.O.C"
      countrycode: "TW"
      issuer: "CTBC Bank"
      issuer_zh_tw: "中國信託銀行(CTBC Bank)"
      lastfour: "4242"
      */
      // userCards.push(action.card);

      return { ...state/*, user_cards: userCards */ };

    case types.LOAD_CARDS_REQUEST:
    case types.LOAD_CARDS_FAILED:
    case types.UPDATE_CARD_REQUEST:
    case types.UPDATE_CARD_FAILED:
    case types.REMOVE_CARD_REQUEST:
    case types.REMOVE_CARD_FAILED:
      return { ...state };

    case types.LOAD_CARDS_COMPLETED:
      // if (action.data) {
        userCards = action.data;
      // } else {
      //   const cardNo = Cookies.get('card_no') || null;
      //   const issuer = Cookies.get('issuer') || null;

      //   if (cardNo && issuer) {
      //     userCards.push({ card_no: cardNo, issuer: issuer });
      //   }
      // }

      return { ...state, user_cards: userCards };

    case types.UPDATE_CARD_COMPLETED:
      return { ...state, user_cards: action.data };

    case types.REMOVE_CARD_COMPLETED:
      return { ...state, user_cards: action.data };

    default: return state;
  }
}

export const actions = {
  setBindCard: function (canBind) {
    return { type: types.SET_BIND_CARD, can_bind: canBind };
  },
  setUserCard: function (card) {
    return { type: types.SET_CARD, card: card };
  },
  updateUserCardRequest: function (card) {
    return { type: types.UPDATE_CARD_REQUEST, card: card };
  },
  updateUserCardCompleted: function(data) {
    return { type: types.UPDATE_CARD_COMPLETED, data: data };
  },
  updateUserCardFailed: function(error) {
    return { type: types.UPDATE_CARD_FAILED, error: error };
  },
  removeUserCardRequest: function(card) {
    return { type: types.REMOVE_CARD_REQUEST, card: card };
  },
  removeUserCardCompleted: function(data) {
    return { type: types.REMOVE_CARD_COMPLETED, data: data };
  },
  removeUserCardFailed: function(error) {
    return { type: types.REMOVE_CARD_FAILED, error: error };
  }
}
